<template>
  <div class="lxm-login">
    <transition name="lxm-transition" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../styles/index.styl'
  .lxm-login
    width: 100vw
    display: flex
    min-height: siz(667)
    flex-direction: column
    background-color: white
</style>

<script>
  export default {
    computed: {
      //
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?de6ca0c2